export const labelToKey: Record<string, string> = {
    'Personal Info': 'personal_info',
    'Additional Details': 'additional_details',
    'Family Members': 'family_member',
    'Language Proficiency': 'language',
    Education: 'education',
    'Work Experience': 'work_experience',
    'Job Offer': 'job_offer',
    'Relatives Abroad': 'relative_abroad',
    'Business Ownership': 'business',
    'Spouse/Common Law Partner': 'spouse',
    Purpose: 'purpose',
};

export const frLabelToKey: Record<string, string> = {
    'Informations personnelles': 'personal_info',
    'Détails supplémentaires': 'additional_details',
    'Membres de la famille': 'family_member',
    'Maîtrise de la langue': 'language',
    Éducation: 'education',
    "L'expérience professionnelle": 'work_experience',
    "Offre d'emploi": 'job_offer',
    "Parents à l'étranger": 'relative_abroad',
    "Propriété de l'entreprise": 'business',
    'Époux/conjoint de fait': 'spouse',
};

export const frenchName: Record<string, string> = {
    'Personal Info': 'Informations personnelles',
    'Additional Details': 'Détails supplémentaires',
    'Language Proficiency': 'Maîtrise de la langue',
    Education: 'Éducation',
    'Work Experience': "L'expérience professionnelle",
    'Job Offer': "Offre d'emploi",
    'Relatives Abroad': "Parents à l'étranger",
    'Business Ownership': "Propriété de l'entreprise",
    'Spouse/Common Law Partner': 'Époux/conjoint de fait',
    'Family Members': 'Membres de la famille',
};
